import React, { useState } from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { Trophy, Medal, Globe, Award } from 'lucide-react';

const sukmaNational = [
  {
    year: '1990',
    event: 'Kejuaraan SUKMA III',
    venue: 'Malaysia',
    result: 'Juara Keseluruhan',
    medals: '6E • 3P • 1G',
    tier: 'gold',
  },
  {
    year: '1992',
    event: 'Kejuaraan SUKMA IV',
    venue: 'Malaysia',
    result: 'Juara Keseluruhan',
    medals: '—',
    tier: 'gold',
  },
  {
    year: '1994',
    event: 'Kejuaraan Silat Kebangsaan',
    venue: 'Malaysia',
    result: 'Juara Keseluruhan',
    medals: '—',
    tier: 'gold',
  },
  {
    year: '1996',
    event: 'Kejuaraan Silat Kebangsaan',
    venue: 'Malaysia',
    result: 'Juara Keseluruhan',
    medals: '—',
    tier: 'gold',
  },
  {
    year: '2000',
    event: 'Kejuaraan Silat Kebangsaan',
    venue: 'Malaysia',
    result: 'Juara Keseluruhan',
    medals: '—',
    tier: 'gold',
  },
  {
    year: '2016',
    event: 'Kejuaraan SUKMA XVIII',
    venue: 'Sarawak',
    result: 'Juara Keseluruhan',
    medals: '—',
    tier: 'gold',
  },
  {
    year: '2018',
    event: 'Kejuaraan SUKMA XIX',
    venue: 'Perak',
    result: 'Juara Ketiga',
    medals: '—',
    tier: 'bronze',
  },
  {
    year: '2024',
    event: 'SUKMA XXI',
    venue: 'Sarawak',
    result: 'Naib Juara',
    medals: '—',
    tier: 'silver',
  },
  {
    year: '2025',
    event: 'Kejuaraan Silat Kebangsaan ke-21',
    venue: 'Malaysia',
    result: '1 Emas, 2 Perak, 3 Gangsa',
    medals: '1E • 2P • 3G',
    tier: 'medals',
  },
];

const international = [
  {
    year: '1992',
    event: 'Kejuaraan Silat Sedunia',
    venue: 'Jakarta, Indonesia',
    result: 'Perwakilan Malaysia',
    tier: 'gold',
  },
  {
    year: '1994',
    event: 'Kejuaraan Silat Sedunia',
    venue: 'Hat Yai, Thailand',
    result: 'Perwakilan Malaysia',
    tier: 'gold',
  },
  {
    year: '1997',
    event: 'Kejuaraan Silat Sedunia',
    venue: 'Kuala Lumpur, Malaysia',
    result: 'Perwakilan Malaysia',
    tier: 'gold',
  },
  {
    year: '1997',
    event: 'Sukan SEA XIX',
    venue: 'Jakarta, Indonesia',
    result: 'Perwakilan Malaysia',
    tier: 'silver',
  },
  {
    year: '2004',
    event: 'Kejuaraan Silat Sedunia',
    venue: 'Singapura',
    result: 'Perwakilan Malaysia',
    tier: 'gold',
  },
  {
    year: '2005',
    event: 'Sukan SEA XXIII',
    venue: 'Manila, Filipina',
    result: 'Perwakilan Malaysia',
    tier: 'silver',
  },
  {
    year: '2024',
    event: 'Kejuaraan Silat Dunia ke-20',
    venue: 'Abu Dhabi, UAE',
    result: 'Perwakilan Malaysia',
    tier: 'gold',
  },
  {
    year: '2025',
    event: 'Kejohanan Pra Sukan SEA Games',
    venue: 'Thailand',
    result: 'Perwakilan Malaysia',
    tier: 'silver',
  },
];

const tierConfig = {
  gold: { bg: '#FFFBF0', border: '#D4AF37', badge: '#D4AF37', icon: <Trophy size={14} /> },
  silver: { bg: '#F8F8F8', border: '#9ca3af', badge: '#6b7280', icon: <Medal size={14} /> },
  bronze: { bg: '#FFF8F5', border: '#c2692c', badge: '#c2692c', icon: <Medal size={14} /> },
  medals: { bg: '#FEF2F2', border: '#D71920', badge: '#D71920', icon: <Award size={14} /> },
};

const AchievementCard = ({ item, type }) => {
  const config = tierConfig[item.tier] || tierConfig.gold;
  return (
    <div
      className="bg-white border rounded overflow-hidden hover:shadow-md transition-shadow"
      style={{ borderColor: config.border }}
      data-testid={`achievement-card-${item.year}`}
    >
      <div className="h-1" style={{ backgroundColor: config.border }} />
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <span
                className="text-[10px] font-extrabold px-2 py-0.5 rounded text-white"
                style={{ backgroundColor: config.badge }}
              >
                {item.year}
              </span>
              {type === 'international' && (
                <Globe size={11} className="text-[#999]" />
              )}
            </div>
            <h3 className="font-bold text-[#0B0B0B] text-sm leading-tight mb-1">{item.event}</h3>
            <p className="text-xs text-[#777] mb-2">{item.venue}</p>
            <div
              className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full"
              style={{ backgroundColor: config.bg, color: config.badge, border: `1px solid ${config.border}30` }}
            >
              {config.icon}
              {item.result}
            </div>
          </div>
          {item.medals && item.medals !== '—' && (
            <div className="text-right flex-shrink-0">
              <div className="text-xs text-[#999] mb-0.5">Pingat</div>
              <div className="text-sm font-extrabold text-[#0B0B0B]">{item.medals}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default function Pencapaian() {
  const [tab, setTab] = useState('sukma');

  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Pencapaian</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" data-testid="pencapaian-title">
            Pencapaian RSS Sarawak
          </h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-2xl">
            Rekod kejayaan pesilat dan pasukan Sarawak di peringkat kebangsaan dan antarabangsa sejak 1990.
          </p>
        </div>
      </div>

      {/* Highlight Stats */}
      <div className="bg-[#D71920] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:divide-x sm:divide-white/20">
            {[
              { value: '5×', label: 'Juara Keseluruhan', sub: 'SUKMA & Kebangsaan' },
              { value: '8', label: 'Kejuaraan Sedunia', sub: 'Penyertaan & Pingat' },
              { value: '2', label: 'Sukan SEA', sub: 'Perwakilan Malaysia' },
              { value: '1990', label: 'Bermula Sejak', sub: 'SUKMA III' },
            ].map((s, i) => (
              <div key={i} className="text-center sm:px-4">
                <div className="text-2xl font-extrabold text-[#FFD21F]">{s.value}</div>
                <div className="text-xs font-bold text-white mt-0.5">{s.label}</div>
                <div className="text-xs text-white/70">{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Nav */}
      <div className="bg-white border-b border-[#E5E5E5] sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex gap-0">
            {[
              { key: 'sukma', label: 'SUKMA & Kebangsaan', icon: <Trophy size={14} /> },
              { key: 'intl', label: 'Antarabangsa', icon: <Globe size={14} /> },
            ].map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`flex items-center gap-2 px-5 py-4 text-sm font-semibold border-b-2 transition-colors ${
                  tab === t.key
                    ? 'border-[#D71920] text-[#D71920]'
                    : 'border-transparent text-[#555] hover:text-[#0B0B0B]'
                }`}
                data-testid={`tab-${t.key}`}
              >
                {t.icon}
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* SUKMA & Kebangsaan */}
      {tab === 'sukma' && (
        <section className="bg-[#F7F7F7] py-14">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex items-start justify-between mb-8">
              <div>
                <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-2">Rekod Kebangsaan</div>
                <h2 className="text-2xl font-extrabold text-[#0B0B0B]">SUKMA & Kejuaraan Kebangsaan</h2>
              </div>
              <div className="text-xs text-[#999] font-semibold hidden sm:block">
                {sukmaNational.length} rekod
              </div>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {sukmaNational.map((item, i) => (
                <AchievementCard key={i} item={item} type="sukma" />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* International */}
      {tab === 'intl' && (
        <section className="bg-[#F7F7F7] py-14">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex items-start justify-between mb-8">
              <div>
                <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-2">Peringkat Antarabangsa</div>
                <h2 className="text-2xl font-extrabold text-[#0B0B0B]">Kejuaraan Antarabangsa</h2>
              </div>
              <div className="text-xs text-[#999] font-semibold hidden sm:block">
                {international.length} rekod
              </div>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {international.map((item, i) => (
                <AchievementCard key={i} item={item} type="international" />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Note */}
      <section className="bg-white py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="p-5 bg-[#F7F7F7] border border-[#E5E5E5] rounded text-sm text-[#666] leading-relaxed">
            <strong>Nota:</strong> Data pencapaian ini adalah berdasarkan rekod rasmi Rumpun Silat Sarawak. Rekod terperinci
            termasuk nama atlet dan jurulatih yang terlibat boleh diminta daripada Sekretariat RSS Sarawak.
            Untuk pertanyaan lanjut, sila{' '}
            <a href="/hubungi" className="text-[#D71920] font-medium hover:underline">hubungi kami</a>.
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
